import React from "react";
import styles from "./TransferenceRequested.module.css";

import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { Navigate } from "react-router-dom";

const TransferenceRequested = () => {
    return (
        <div style={{marginTop:"13%", padding:"0% 10%", textAlign:"center"}}>
        <Card className={styles.cardMessage}>
        <div className={`pi pi-check-circle ${styles.checkCircleIcon}`}></div>
            <h1>Formulario enviado exitosamente</h1>
            <p >Gracias por su compra. Se le estará notificando a través del correo electrónico asociado a su cuenta una vez el proceso de pago esté completado</p>
            <Button onClick={() => window.location.href = "/mycourses"} className={styles.button} label="Volver a mis cursos" />
        </Card>
        </div>
    );
    }

    export default TransferenceRequested;